import type { DragEventHandler, ReactNode } from 'react'
import cc from 'classcat'

import Button from '../../../../../formComponents/Button'

type PluginPlaceholderProps = {
  iconClassName: string
  onAdd?: () => void
  children?: ReactNode
  info?: ReactNode
  className?: string
  /** Custom action rendered instead of the default onAdd button. Pass null to suppress both. */
  action?: ReactNode
  onDragOver?: DragEventHandler<HTMLDivElement>
  onDrop?: DragEventHandler<HTMLDivElement>
}

export default function PluginPlaceholder({
  iconClassName,
  onAdd,
  children,
  info,
  className,
  action,
  onDragOver,
  onDrop,
}: Readonly<PluginPlaceholderProps>) {
  return (
    <div className={cc(['plugin-placeholder', className])} onDragOver={onDragOver} onDrop={onDrop}>
      <span className={cc(['plugin-placeholder-icon', iconClassName])} aria-hidden="true" />
      {info && <div className="plugin-placeholder-info">{info}</div>}
      {action !== undefined
        ? action
        : onAdd && (
            <Button type="button" onClick={onAdd}>
              {children}
            </Button>
          )}
    </div>
  )
}
